import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",

  initialState: {
    user: null,
    refresh_token: null,
    access_token: null,
    promptEmailUpdate: false,
  },

  reducers: {
    login: (state, action) => {
      const { access_token, refresh_token, user, promptEmailUpdate } = action.payload;
      state.user = user;
      state.access_token = access_token;
      state.refresh_token = refresh_token;
      state.promptEmailUpdate = !!promptEmailUpdate;

      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("access_token", JSON.stringify(access_token));
      localStorage.setItem("refresh_token", JSON.stringify(refresh_token));
    },
    setAccessToken: (state, action) => {
      const { access_token } = action.payload;
      state.access_token = access_token;
      localStorage.setItem("access_token", JSON.stringify(access_token));
    },
    setUser: (state, action) => {
      state.user = { ...state.user, ...action.payload };
      localStorage.setItem("user", JSON.stringify({ ...state.user, ...action.payload }));
    },
    logout: (state) => {
      state.access_token = "";
      state.refresh_token = "";
      state.user = null;
      state.promptEmailUpdate = false;
      localStorage.clear();
    },
    clearEmailUpdatePrompt: (state) => {
      state.promptEmailUpdate = false;
    },
  },
});

export const { login, setAccessToken, setUser, logout, clearEmailUpdatePrompt } = authSlice.actions;

export const authReducer = authSlice.reducer;

export const selectCurrentUser = (state) => state.auth.user;
export const selectCurrentToken = (state) => state.auth.access_token;
export const selectPromptEmailUpdate = (state) => state.auth.promptEmailUpdate;
